<template>
    <div class="faq-question">
        <div class="faq-question__header" @click="active=!active">
            <div class="faq-question__icon">
                <i class="fas fa-minus" v-if="active"></i>
                <i class="fas fa-plus" v-else></i>
            </div>
            <div class="faq-question__question">
                {{question}}
            </div>
        </div>
        <transition name="slide-fade">
            <div class="faq-question__answer" v-if="active">
                {{answer}}
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                active: false
            }
        },
        props: {
            question: {
                type: String,
                default: ''
            },
            answer: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .faq-question {
        margin: 25px 0;
        max-width: 100%;
        position: relative;
        padding-bottom: 25px;
        border-bottom: 1px solid rgba($color-gray, .25);
        transition: color, .2s;

        &:hover {
            color: $color-primary;
        }

        &__header {
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
        }

        &__icon {
            font-size: 22px;
            color: $color-secondary;
        }

        &__question {
            margin-left: 20px;
            font-size: 20px;
            font-weight: 500;
            line-height: 25px;
        }

        &__answer {
            margin-left: 40px;
            margin-top: 20px;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: $color-gray;
            opacity: .7;
            padding-left: 10px;
            border-left: 2px solid $color-secondary;

            @include media-breakpoint-up(sm) {
                margin-left: 65px;
            }
        }
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .3s ease;
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }
</style>